var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frameHome"},[(_vm.isSimpleHeader)?_c('SimpleHeader'):_c('Header',{attrs:{"isMobile":_vm.isMobile}}),_c('div',{class:[_vm.isHomePage ? 'page-full' : 'page']},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_c('Footer',{attrs:{"isMobile":_vm.isMobile}}),_c('Notice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }